import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useGetMasterDivisi } from '../../GQL/Divisi/useGetMasterDivisi';
import { filterJobAtom } from '../../shared/globalStates';
import CustomNativeSelect from './CustomNativeSelect';

function NativeSelectMasterDivisi(resetOnMount, resetOnUnmount) {
    const [Divisi,] = useGetMasterDivisi()
    const [filter, setFilter] = useRecoilState(filterJobAtom);

    const handleChange = (e) => {
        // if (!filter.includes(e.target.value)) {
            // setFilter((prevData) => [...prevData, e.target.value]);
            // setFilter((prevData) => [e.target.value]);
            // setFilter([e.target.value]);
            // setFilter(e.target.value);
            setFilter({divisi: e.target.value, ...filter});
        // }
    };

    return (
        <CustomNativeSelect
            icon="work"
            handleSelect={handleChange}
        >
            <option value="">Select Function</option>
            {
                Divisi.data?.map((div) => (
                    <option
                        key={div.id}
                        value={div.division}
                    >
                        {div.division}
                    </option>
                ))
            }
        </CustomNativeSelect>
    )
}

export default NativeSelectMasterDivisi